import { supabase } from "./supabase";
export const db = {
  async products({
    q = "",
    category = "",
    status = "active",
    limit = 100,
  } = {}) {
    let x = supabase
      .from("products")
      .select(
        "*,categories(id,name,slug),product_images(id,storage_path,alt_text,sort_order,is_primary)",
      )
      .order("created_at", { ascending: false })
      .limit(limit);
    if (status !== "all") x = x.eq("status", status);
    if (category) x = x.eq("category_id", category);
    if (q)
      x = x.or(`name.ilike.%${q}%,sku.ilike.%${q}%,display_name.ilike.%${q}%`);
    const { data, error } = await x;
    if (error) throw error;
    return data || [];
  },
  async product(slug) {
    const { data, error } = await supabase
      .from("products")
      .select(
        "*,categories(id,name,slug),product_images(id,storage_path,alt_text,sort_order,is_primary)",
      )
      .eq("slug", slug)
      .maybeSingle();
    if (error) throw error;
    return data;
  },
  async deleteProduct(id) {
    const { error } = await supabase
      .from("products")
      .update({ status: "archived" })
      .eq("id", id);
    if (error) throw error;
  },
  async categories() {
    const { data, error } = await supabase
      .from("categories")
      .select("*")
      .eq("is_active", true)
      .order("sort_order");
    if (error) throw error;
    return data || [];
  },
  async customers() {
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("role", "customer")
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data || [];
  },
  async orders({ customerId } = {}) {
    let x = supabase
      .from("orders")
      .select("*,order_items(*)")
      .order("created_at", { ascending: false });
    if (customerId) x = x.eq("customer_id", customerId);
    const { data, error } = await x;
    if (error) throw error;
    return data || [];
  },
  async tickets({ customerId, technicianId } = {}) {
    let x = supabase
      .from("service_tickets")
      .select(
        "*,products(name,display_name,sku),profiles!service_tickets_customer_id_fkey(full_name,phone),technicians(id,user_id,service_zone)",
      )
      .order("created_at", { ascending: false });
    if (customerId) x = x.eq("customer_id", customerId);
    if (technicianId) x = x.eq("assigned_technician_id", technicianId);
    const { data, error } = await x;
    if (error) throw error;
    return data || [];
  },
  async technicians() {
    const { data, error } = await supabase
      .from("technicians")
      .select("*,profiles(full_name,email,phone)")
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data || [];
  },
  async inventory() {
    const { data, error } = await supabase
      .from("inventory")
      .select("*,products(name,sku,retail_price)")
      .order("updated_at", { ascending: false });
    if (error) throw error;
    return data || [];
  },
  async addresses(userId) {
    const { data, error } = await supabase
      .from("addresses")
      .select("*")
      .eq("user_id", userId)
      .order("is_default", { ascending: false });
    if (error) throw error;
    return data || [];
  },
  async notifications(userId) {
    const { data, error } = await supabase
      .from("notifications")
      .select("*")
      .eq("user_id", userId)
      .order("created_at", { ascending: false });
    if (error) throw error;
    return data || [];
  },
  async wishlist(userId) {
    let { data, error } = await supabase
      .from("wishlists")
      .select("id")
      .eq("user_id", userId)
      .maybeSingle();
    if (error) throw error;
    if (!data) {
      const r = await supabase
        .from("wishlists")
        .insert({ user_id: userId })
        .select("id")
        .single();
      if (r.error) throw r.error;
      data = r.data;
    }
    const r = await supabase
      .from("wishlist_items")
      .select("product_id,products(*)")
      .eq("wishlist_id", data.id);
    if (r.error) throw r.error;
    return r.data || [];
  },
};